import { useTranslation } from 'react-i18next';
import termsHtmlByLocale from '../../assets/terms-and-conditions/terms-html.json';

export const useTermsHtml = (): string | null => {
  const { i18n } = useTranslation();
  const html = termsHtmlByLocale[i18n.language as keyof typeof termsHtmlByLocale];

  return html ?? null;
};
